import { c } from "react-compiler-runtime";
import { useEffect } from "react";
import { $getSelection, $isRangeSelection, PASTE_COMMAND } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { cleanUnicodeCharacters } from "../../utils/index.js";
const PasteCleanupPlugin = ()=>{
    const $ = c(3);
    const [editor] = useLexicalComposerContext();
    let t0;
    let t1;
    if ($[0] !== editor) {
        t0 = ()=>editor.registerCommand(PASTE_COMMAND, (event)=>{
                const clipboardData = event.clipboardData;
                if (!clipboardData) return false;
                const text = clipboardData.getData("text/plain");
                if (!text) return false;
                const cleanText = cleanUnicodeCharacters(text);
                editor.update(()=>{
                    const selection = $getSelection();
                    if ($isRangeSelection(selection)) selection.insertText(cleanText);
                });
                event.preventDefault();
                return true;
            }, 1);
        t1 = [
            editor
        ];
        $[0] = editor;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    useEffect(t0, t1);
    return null;
};
export { PasteCleanupPlugin };
